import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class FileCheckerService {
  public isAcceptedFileMimeType(fileMimeType: string): boolean {

    switch (fileMimeType) {
      case "text/plain":
      case "text/x-csv":
      case "text/csv":
      case "text/comma-separated-values":
      case "text/x-comma-separated-values":
      case "text/tab-separated-values":
      case "application/vnd.ms-excel":
      case "application/csv":
      case "application/x-csv":
      case "application/pdf":
        return true;

      default:
        return false;
    }
  }
}
